<template>
  <div class="mobile">
    <div class="main">
      <div class="headerBox"></div>
      <div v-if="showImg">
        <img
          v-for="(item, index) in urlList"
          :key="index"
          :src="item.url"
          width="1"
          height="1"
          @error="autoTest(item, index)"
          style="display: none"
        />
      </div>
      <div class="appArea">
        <div v-for="(item, index) in urlList" :key="item.url">
          <div :class="['appBox', 'appBox' + index]" v-if="index < 8">
            <div class="btn1" @click="jumpUrl(item.url)"></div>
            <div class="btn2" @click="jumpUrl(item.webUrl || item.url)"></div>
          </div>
          <div :class="['colAppBox', 'colAppBox' + index]" v-else>
            <div class="timeConsuming">
              <span v-if="item.time == 0">检测中...</span
              ><span v-else
                ><span v-if="item.time < 50" class="green"
                  >{{ item.time }}MS</span
                >
                <span v-if="item.time >= 50 && item.time < 100" class="orange"
                  >{{ item.time }}MS</span
                >
                <span v-if="item.time >= 100" class="red"
                  >{{ item.time }}MS</span
                ></span
              >
            </div>
            <div class="btn1" @click="jumpUrl(item.url)"></div>
          </div>
        </div>
      </div>
      <div class="bottomBox">
        <div class="joinBtn" @click="jumpUrl('https://t.me/aguaguagu159')"></div>
        <div class="refreshBtn" @click="reset"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { mixins } from "./../../../mixin/index";
export default {
  name: "mobile",
  mixins: [mixins],
};
</script>
<style lang="scss" scoped>
.mobile {
  height: 100%;
  overflow-y: auto;
  background: black;

  .main {
    height: 1480px;
    padding: 0px 16px;
    background: url("./../../../assets/png/mobileBg.webp") no-repeat;
    background-size: contain;
    .headerBox {
      height: 212px;
    }
    .appArea {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 100px;
      .appBox {
        height: 76px;
        width: 343px;
        margin-bottom: 13px;
        position: relative;
        .btn1 {
          width: 85px;
          height: 22px;
          position: absolute;
          left: 102px;
          bottom: 12px;
        }
        .btn2 {
          width: 85px;
          height: 22px;
          position: absolute;
          left: 220px;
          bottom: 12px;
        }
      }
      @for $i from 0 through 7 {
        .appBox#{$i} {
          background: url('./../../../assets/png/mobile/img/#{$i}.png');
          background-size: 100% 100%;
        }
      }
      .colAppBox {
        position: relative;
        height: 64px;
        width: 165px;
        margin-bottom: 12px;
        position: relative;
        .btn1 {
          width: 44px;
          height: 25px;
          position: absolute;
          right: 9px;
          bottom: 20px;
        }
      }
      @for $i from 8 through 14 {
        .colAppBox#{$i} {
          background: url('./../../../assets/png/mobile/img1/#{$i}.png');
          background-size: 100% 100%;
        }
      }
    }
    .bottomBox {
      height: 90px;
      width: 375px;
      background: url("./../../../assets/png/bottomBox.webp") no-repeat;
      background-size: 100% 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      .joinBtn {
        position: absolute;
        top: 10px;
        left: 50%;
        height: 41px;
        width: 343px;
        transform: translate(-50%, 0);
      }
      .refreshBtn {
        position: absolute;
        bottom: 10px;
        left: 50%;
        height: 20px;
        width: 213px;
        transform: translate(-50%, 0);
      }
    }
  }
}

.timeConsuming {
  color: #31ffe4;
  font-size: 12px;
  position: absolute;
  bottom: 16px;
  left: 57px;
  width: 50px;
  padding-left: 1px;
  background: #10121d;
}
.green {
  color: #31ffe4;
}
.orange {
  color: #f5a937;
}
.red {
  color: #e93333;
}

</style>
